<!-- Section 1: Pieprasījums -->
<div class="section no-padding" [ngClass]="{ open: isRequestExpanded }">
  <div class="heading-wrapper"
    (keydown.enter)="toggleRequestSection()"
    (click)="toggleRequestSection()"
    tabindex="0">
    <div class="inline">
      <img [ngClass]="{ chevron: true, open: isRequestExpanded }" src="assets/images/chevron-icon.svg" alt="arrow" />
      <h4>{{ 'pages.service.infoRequest.requestSection' | translate }}</h4>
    </div>
    <div class="actions">
      <button class="tertiary" (click)="editStep(1); $event.stopPropagation()">
        <img src="assets/images/edit-icon.svg" alt="edit" />
        {{ 'pages.service.infoRequest.edit' | translate }}
      </button>
    </div>
  </div>

  <div class="section-content" [ngbCollapse]="!isRequestExpanded">
    <!-- Selected topic -->
    <div class="summary-card">
      <div class="summary-field">
        <p class="form-label">{{ 'pages.service.infoRequest.topicLabel' | translate }}</p>
        <p class="form-value">{{ topicName }}</p>
      </div>
    </div>

    <!-- Topic fields grouped by block -->
    @for (block of topicBlocks; track block.blockNumber) {
      <div class="summary-card">
        @if (block.title) {
          <h5>{{ block.title }}</h5>
        }
        @for (field of block.fields; track field.key) {
          <div class="summary-field">
            <p class="form-label">{{ field.label }}</p>
            <p class="form-value">{{ field.value }}</p>
          </div>
        }

        @if (block.tableRows.length > 0) {
          @if (block.tableSectionTitle) {
            <p class="form-label table-section-label">{{ block.tableSectionTitle }}</p>
          }
          <div class="ro-table-section">
            <div class="ro-table-border">
              <div class="ro-table-row ro-table-header-row">
                <div class="ro-table-row-fields">
                  @for (col of block.tableColumns; track col.key) {
                    <div class="ro-table-header-cell">{{ col.label }}</div>
                  }
                </div>
              </div>
              <div class="ro-table-rows">
                @for (row of block.tableRows; track $index) {
                  <div class="ro-table-row">
                    <div class="ro-table-row-fields">
                      @for (col of block.tableColumns; track col.key) {
                        <div class="ro-table-cell">{{ row[col.key] || '-' }}</div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }

      </div>
    }

    <!-- Documents -->
    @if (hasDocumentFiles()) {
      <div class="summary-documents">
        <p class="form-label summary-documents-label">{{ 'pages.service.infoRequest.documents' | translate }}</p>
        @for (file of existingDocumentFiles; track file.outerId) {
          <div class="summary-file-entry">
            <div class="summary-file-row">
              <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
              <span class="summary-file-name" (click)="downloadServerFile(file)">{{ file.uploadFileName }} ({{ formatFileSize(file.length!) }})</span>
            </div>
            @if (getServerFileDescription(file); as desc) {
              <p class="summary-file-description">{{ desc }}</p>
            }
          </div>
        }
        @for (file of pendingDocumentFiles; track file.name) {
          <div class="summary-file-entry">
            <div class="summary-file-row">
              <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
              <span class="summary-file-name" (click)="downloadLocalFile(file)">{{ file.name }} ({{ formatFileSize(file.size) }})</span>
            </div>
            @if (getFileDescription(file.name, documentFiles.descriptions); as desc) {
              <p class="summary-file-description">{{ desc }}</p>
            }
          </div>
        }
      </div>
    }
  </div>
</div>

<!-- Section 2: Klients un maksātājs -->
<div class="section no-padding" [ngClass]="{ open: isClientPayerExpanded }">
  <div class="heading-wrapper"
    (keydown.enter)="toggleClientPayerSection()"
    (click)="toggleClientPayerSection()"
    tabindex="0">
    <div class="inline">
      <img [ngClass]="{ chevron: true, open: isClientPayerExpanded }" src="assets/images/chevron-icon.svg" alt="arrow" />
      <h4>{{ labels.section('clientPayer') }}</h4>
    </div>
    <div class="actions">
      <button class="tertiary" (click)="editStep(2); $event.stopPropagation()">
        <img src="assets/images/edit-icon.svg" alt="edit" />
        {{ 'pages.service.infoRequest.edit' | translate }}
      </button>
    </div>
  </div>

  <div class="section-content" [ngbCollapse]="!isClientPayerExpanded">
    <!-- Informācijas pieprasītājs -->
    <div class="summary-subsection">
      <div class="summary-subsection-header">
        <h5 class="summary-subsection-title">{{ labels.section('submitter') }}</h5>
        <app-tooltip text="infoRequestRequester" />
      </div>

      @if (!isOrganization) {
        <div class="summary-grid">
          @for (row of labels.nameRows('submitter', application.client?.name, application.client?.surname); track $index) {
            <div class="summary-field">
              <p class="form-label">{{ row.label }}</p>
              <p class="form-value">{{ row.value }}</p>
            </div>
          }
          <div class="summary-field">
            <p class="form-label">{{ labels.field('submitter','personalCode') }}</p>
            <p class="form-value">{{ application.personalCode || application.client?.personalCode || '-' }}</p>
          </div>
          <div class="summary-field">
            <p class="form-label">{{ labels.field('submitter','email') }}</p>
            <p class="form-value">{{ application.client?.email || application.clientInfo?.email || '-' }}</p>
          </div>
          <div class="summary-field">
            <p class="form-label">{{ labels.field('submitter','phone') }}</p>
            <p class="form-value">{{ application.client?.phone || application.clientInfo?.phone || '-' }}</p>
          </div>
        </div>
      } @else {
        <div class="summary-grid">
          <div class="summary-field">
            <p class="form-label">{{ labels.field('submitter','legalEntityName') }}</p>
            <p class="form-value">{{ getCompanyNameDisplay() }}</p>
          </div>
          <div class="summary-field">
            <p class="form-label">{{ labels.field('submitter','registrationNumber') }}</p>
            <p class="form-value">{{ getRegistrationNumberDisplay() }}</p>
          </div>
          <div class="summary-field">
            <p class="form-label">{{ labels.field('submitter','registrationCountry') }}</p>
            <p class="form-value">{{ getRegistrationCountryDisplay() }}</p>
          </div>
          <div class="summary-field">
            <p class="form-label">{{ labels.field('submitter','legalAddress') }}</p>
            <p class="form-value">{{ getLegalAddressDisplay() }}</p>
          </div>
          <div class="summary-field">
            <p class="form-label">{{ labels.field('submitter','legalForm') }}</p>
            <p class="form-value">{{ getLegalFormDisplay() }}</p>
          </div>
          <div class="summary-field">
            <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.companyPhone' | translate }}</p>
            <p class="form-value">{{ getCompanyPhoneDisplay() }}</p>
          </div>
          <div class="summary-field">
            <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.companyEmail' | translate }}</p>
            <p class="form-value">{{ getCompanyEmailDisplay() }}</p>
          </div>
        </div>
      }
    </div>

    <!-- Kontaktpersona (JP only) -->
    @if (isOrganization) {
      <div class="summary-subsection">
        <div class="summary-subsection-header">
          <h5 class="summary-subsection-title">{{ labels.field('submitter','contactPerson') }}</h5>
        </div>
        <div class="summary-grid">
          @for (row of labels.nameRows('contactPerson', jpCompanyData['contactPersonName'] || application.contactPersonName, jpCompanyData['contactPersonSurname'] || application.contactPersonSurname); track $index) {
            <div class="summary-field">
              <p class="form-label">{{ row.label }}</p>
              <p class="form-value">{{ row.value }}</p>
            </div>
          }
          <div class="summary-field">
            <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.email' | translate }}</p>
            <p class="form-value">{{ getContactPersonEmailDisplay() }}</p>
          </div>
          <div class="summary-field">
            <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.phone' | translate }}</p>
            <p class="form-value">{{ getContactPersonPhoneDisplay() }}</p>
          </div>
        </div>
      </div>
    }

    <!-- Informāciju pieprasu (FP) -->
    @if (!isOrganization && application.requesterRelationType) {
      <div class="summary-subsection">
        <div class="summary-subsection-header">
          <h5 class="summary-subsection-title">{{ labels.section('requester') }}</h5>
          <app-tooltip text="infoRequestRelationType" />
        </div>
        <p class="form-value">{{ requesterRelationLabel }}</p>

        <!-- Authorization/Permission card -->
        @if ((application.requesterRelationType === 'ForOtherPerson' || application.requesterRelationType === 'Unknown') && requesterForOtherPersonType === 'AuthorizationOrPermission' && parsedRequesterData) {
          <div class="summary-card">
            <h5>{{ labels.field('requester', 'authCardTitle') }}</h5>
            <div class="summary-grid">
              @for (row of labels.nameRows('requester', parsedRequesterData['name'], parsedRequesterData['surname']); track $index) {
                <div class="summary-field">
                  <p class="form-label">{{ row.label }}</p>
                  <p class="form-value">{{ row.value }}</p>
                </div>
              }
              <div class="summary-field">
                <p class="form-label">{{ labels.requester('personalCode') }}</p>
                <p class="form-value">{{ parsedRequesterData['personalCode'] || '-' }}</p>
              </div>
            </div>
            <div class="summary-field">
              <p class="form-label">{{ labels.requester('authorizationNumber') }}</p>
              <p class="form-value">{{ parsedRequesterData['authorizationNumber'] || '-' }}</p>
            </div>
            @if (hasClientPayerFiles('authorization')) {
              <div class="summary-documents">
                <p class="form-label summary-documents-label">{{ 'pages.service.infoRequest.documents' | translate }}</p>
                @for (file of getExistingClientPayerFiles('authorization'); track file.outerId) {
                  <div class="summary-file-entry">
                    <div class="summary-file-row">
                      <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
                      <span class="summary-file-name" (click)="downloadServerFile(file)">{{ file.uploadFileName }} ({{ formatFileSize(file.length!) }})</span>
                    </div>
                    @if (getClientPayerServerFileDescription(file, 'authorization'); as desc) {
                      <p class="summary-file-description">{{ desc }}</p>
                    }
                  </div>
                }
                @for (file of getPendingClientPayerFiles('authorization'); track file.name) {
                  <div class="summary-file-entry">
                    <div class="summary-file-row">
                      <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
                      <span class="summary-file-name" (click)="downloadLocalFile(file)">{{ file.name }} ({{ formatFileSize(file.size) }})</span>
                    </div>
                    @if (getFileDescription(file.name, clientPayerFiles['authorization'].descriptions); as desc) {
                      <p class="summary-file-description">{{ desc }}</p>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }

        <!-- Deceased relative card -->
        @if ((application.requesterRelationType === 'ForOtherPerson' || application.requesterRelationType === 'Unknown') && requesterForOtherPersonType === 'DeceasedRelative' && parsedRequesterData) {
          <div class="summary-card">
            <h5>{{ labels.field('requester', 'deceasedCardTitle') }}</h5>
            <div class="summary-field">
              <p class="form-label">{{ labels.requester('relationshipType') }}</p>
              <p class="form-value">{{ parsedRequesterData['relationshipType'] || '-' }}</p>
            </div>
            <div class="summary-grid">
              @for (row of labels.nameRows('requester', parsedRequesterData['name'], parsedRequesterData['surname']); track $index) {
                <div class="summary-field">
                  <p class="form-label">{{ row.label }}</p>
                  <p class="form-value">{{ row.value }}</p>
                </div>
              }
              <div class="summary-field">
                <p class="form-label">{{ labels.requester('personalCode') }}</p>
                <p class="form-value">{{ parsedRequesterData['personalCode'] || '-' }}</p>
              </div>
            </div>
            @if (parsedRequesterData['deathCertificateData']) {
              <div class="summary-field">
                <p class="form-label">{{ labels.requester('deathCertificateData') }}</p>
                <p class="form-value">{{ parsedRequesterData['deathCertificateData'] }}</p>
              </div>
            }
            @if (hasClientPayerFiles('deathCertificate')) {
              <div class="summary-documents">
                <p class="form-label summary-documents-label">{{ 'pages.service.infoRequest.documents' | translate }}</p>
                @for (file of getExistingClientPayerFiles('deathCertificate'); track file.outerId) {
                  <div class="summary-file-entry">
                    <div class="summary-file-row">
                      <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
                      <span class="summary-file-name" (click)="downloadServerFile(file)">{{ file.uploadFileName }} ({{ formatFileSize(file.length!) }})</span>
                    </div>
                    @if (getClientPayerServerFileDescription(file, 'deathCertificate'); as desc) {
                      <p class="summary-file-description">{{ desc }}</p>
                    }
                  </div>
                }
                @for (file of getPendingClientPayerFiles('deathCertificate'); track file.name) {
                  <div class="summary-file-entry">
                    <div class="summary-file-row">
                      <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
                      <span class="summary-file-name" (click)="downloadLocalFile(file)">{{ file.name }} ({{ formatFileSize(file.size) }})</span>
                    </div>
                    @if (getFileDescription(file.name, clientPayerFiles['deathCertificate'].descriptions); as desc) {
                      <p class="summary-file-description">{{ desc }}</p>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }

        <!-- Other case description -->
        @if ((application.requesterRelationType === 'OtherCase' || requesterForOtherPersonType === 'Other') && parsedRequesterData?.['description']) {
          <div class="summary-card">
            <h5>{{ 'pages.service.infoRequest.clientPayer.additionalInfo' | translate }}</h5>
            <p class="form-value">{{ parsedRequesterData?.['description'] }}</p>
          </div>
        }
      </div>
    }

    <!-- JP Authorization -->
    @if (isOrganization && requesterForOtherPersonType === 'AuthorizationOrPermission' && parsedRequesterData) {
      <div class="summary-subsection">
        <div class="summary-subsection-header">
          <h5 class="summary-subsection-title">{{ labels.section('requester') }}</h5>
          <app-tooltip text="infoRequestRelationType" />
        </div>
        <p class="form-value">{{ labels.field('requester', 'jpAuthorization') }}</p>

        <div class="summary-card">
          <h5>{{ labels.field('requester', 'authCardTitle') }}</h5>
          <div class="summary-grid">
            @for (row of labels.nameRows('requester', parsedRequesterData['name'], parsedRequesterData['surname']); track $index) {
              <div class="summary-field">
                <p class="form-label">{{ row.label }}</p>
                <p class="form-value">{{ row.value }}</p>
              </div>
            }
            <div class="summary-field">
              <p class="form-label">{{ labels.requester('personalCode') }}</p>
              <p class="form-value">{{ parsedRequesterData['personalCode'] || '-' }}</p>
            </div>
          </div>
          <div class="summary-field">
            <p class="form-label">{{ labels.requester('authorizationNumber') }}</p>
            <p class="form-value">{{ parsedRequesterData['authorizationNumber'] || '-' }}</p>
          </div>
          @if (hasClientPayerFiles('jpAuthorization')) {
            <div class="summary-documents">
              <p class="form-label summary-documents-label">{{ 'pages.service.infoRequest.documents' | translate }}</p>
              @for (file of getExistingClientPayerFiles('jpAuthorization'); track file.outerId) {
                <div class="summary-file-entry">
                  <div class="summary-file-row">
                    <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
                    <span class="summary-file-name" (click)="downloadServerFile(file)">{{ file.uploadFileName }} ({{ formatFileSize(file.length!) }})</span>
                  </div>
                  @if (getClientPayerServerFileDescription(file, 'jpAuthorization'); as desc) {
                    <p class="summary-file-description">{{ desc }}</p>
                  }
                </div>
              }
              @for (file of getPendingClientPayerFiles('jpAuthorization'); track file.name) {
                <div class="summary-file-entry">
                  <div class="summary-file-row">
                    <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
                    <span class="summary-file-name" (click)="downloadLocalFile(file)">{{ file.name }} ({{ formatFileSize(file.size) }})</span>
                  </div>
                  @if (getFileDescription(file.name, clientPayerFiles['jpAuthorization'].descriptions); as desc) {
                    <p class="summary-file-description">{{ desc }}</p>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    <!-- Discount group -->
    @if (application.discountGroupType && (!isOrganization || requesterForOtherPersonType === 'AuthorizationOrPermission')) {
      <div class="summary-subsection">
        <div class="summary-subsection-header">
          <h5 class="summary-subsection-title">{{ labels.section('discount') }}</h5>
          <app-tooltip text="infoRequestDiscountGroup" />
        </div>
        <p class="form-value">{{ getDiscountLabel() }}</p>

        @if ((application.discountGroupType === 'ChildProtection' || application.discountGroupType === 'OtherCase') && parsedDiscountData) {
          <div class="summary-card">
            <h5>{{ discountCardTitle }}</h5>
            <div class="summary-field">
              <p class="form-label">{{ labels.discount('reason') }}</p>
              <p class="form-value">{{ parsedDiscountData['reason'] || '-' }}</p>
            </div>
            @if (hasClientPayerFiles('discountGroup')) {
              <div class="summary-documents">
                <p class="form-label summary-documents-label">{{ 'pages.service.infoRequest.documents' | translate }}</p>
                @for (file of getExistingClientPayerFiles('discountGroup'); track file.outerId) {
                  <div class="summary-file-entry">
                    <div class="summary-file-row">
                      <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
                      <span class="summary-file-name" (click)="downloadServerFile(file)">{{ file.uploadFileName }} ({{ formatFileSize(file.length!) }})</span>
                    </div>
                    @if (getClientPayerServerFileDescription(file, 'discountGroup'); as desc) {
                      <p class="summary-file-description">{{ desc }}</p>
                    }
                  </div>
                }
                @for (file of getPendingClientPayerFiles('discountGroup'); track file.name) {
                  <div class="summary-file-entry">
                    <div class="summary-file-row">
                      <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
                      <span class="summary-file-name" (click)="downloadLocalFile(file)">{{ file.name }} ({{ formatFileSize(file.size) }})</span>
                    </div>
                    @if (getFileDescription(file.name, clientPayerFiles['discountGroup'].descriptions); as desc) {
                      <p class="summary-file-description">{{ desc }}</p>
                    }
                  </div>
                }
              </div>
            }
          </div>
        } @else if (parsedDiscountData && application.discountGroupType !== 'None') {
          <div class="summary-card">
            <h5>{{ discountCardTitle }}</h5>
            <div class="summary-grid">
              @for (row of labels.nameRows('discount', parsedDiscountData['name'], parsedDiscountData['surname']); track $index) {
                <div class="summary-field">
                  <p class="form-label">{{ row.label }}</p>
                  <p class="form-value">{{ row.value }}</p>
                </div>
              }
              <div class="summary-field">
                <p class="form-label">{{ application.discountGroupType === 'LowIncomePerson'
                      ? labels.discount('documentNumber')
                      : labels.field('discount', 'certificateNumber') }}</p>
                <p class="form-value">{{ parsedDiscountData['documentNumber'] || '-' }}</p>
              </div>
              @if (parsedDiscountData['documentExpiry']) {
                <div class="summary-field">
                  <p class="form-label">{{ labels.discount('documentExpiry') }}</p>
                  <p class="form-value">{{ formatDate(parsedDiscountData['documentExpiry']) }}</p>
                </div>
              }
              @if (parsedDiscountData['documentIssuer']) {
                <div class="summary-field">
                  <p class="form-label">{{ labels.discount('documentIssuer') }}</p>
                  <p class="form-value">{{ parsedDiscountData['documentIssuer'] }}</p>
                </div>
              }
            </div>
            @if (hasClientPayerFiles('discountGroup')) {
              <div class="summary-documents">
                <p class="form-label summary-documents-label">{{ 'pages.service.infoRequest.documents' | translate }}</p>
                @for (file of getExistingClientPayerFiles('discountGroup'); track file.outerId) {
                  <div class="summary-file-entry">
                    <div class="summary-file-row">
                      <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
                      <span class="summary-file-name" (click)="downloadServerFile(file)">{{ file.uploadFileName }} ({{ formatFileSize(file.length!) }})</span>
                    </div>
                    @if (getClientPayerServerFileDescription(file, 'discountGroup'); as desc) {
                      <p class="summary-file-description">{{ desc }}</p>
                    }
                  </div>
                }
                @for (file of getPendingClientPayerFiles('discountGroup'); track file.name) {
                  <div class="summary-file-entry">
                    <div class="summary-file-row">
                      <img class="summary-file-icon" src="assets/images/file-icon.svg" alt="file" />
                      <span class="summary-file-name" (click)="downloadLocalFile(file)">{{ file.name }} ({{ formatFileSize(file.size) }})</span>
                    </div>
                    @if (getFileDescription(file.name, clientPayerFiles['discountGroup'].descriptions); as desc) {
                      <p class="summary-file-description">{{ desc }}</p>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- Payer -->
    <div class="summary-subsection">
      <div class="summary-subsection-header">
        <h5 class="summary-subsection-title">{{ labels.section('payer') }}</h5>
        <app-tooltip text="infoRequestPayer" />
      </div>
      <p class="form-value">{{ getPayerTypeLabel() }}</p>

      @if (application.payerType === 'Requester' && parsedPayerData?.['vatNumber']) {
        <div class="summary-card">
          <div class="summary-grid">
            <div class="summary-field">
              <p class="form-label">{{ labels.payer('vatNumber') }}</p>
              <p class="form-value">{{ parsedPayerData?.['vatNumber'] }}</p>
            </div>
          </div>
        </div>
      }

      @if (application.payerType === 'OtherPhysicalPerson' && parsedPayerData) {
        <div class="summary-card">
          <div class="summary-grid">
            @for (row of labels.nameRows('payer', parsedPayerData['name'], parsedPayerData['surname']); track $index) {
              <div class="summary-field">
                <p class="form-label">{{ row.label }}</p>
                <p class="form-value">{{ row.value }}</p>
              </div>
            }
            @if (parsedPayerData['personalCode']) {
              <div class="summary-field">
                <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.personalCode' | translate }}</p>
                <p class="form-value">{{ parsedPayerData['personalCode'] }}</p>
              </div>
            }
          </div>
        </div>
      }

      @if (application.payerType === 'OtherLegalEntity' && parsedPayerData) {
        <div class="summary-card">
          <div class="summary-grid">
            @if (parsedPayerData['country']) {
              <div class="summary-field">
                <p class="form-label">{{ labels.payer('country') }}</p>
                <p class="form-value">{{ parsedPayerData['country'] }}</p>
              </div>
            }
            @if (parsedPayerData['registrationNumber']) {
              <div class="summary-field">
                <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.registrationNumber' | translate }}</p>
                <p class="form-value">{{ parsedPayerData['registrationNumber'] }}</p>
              </div>
            }
            @if (parsedPayerData['vatNumber']) {
              <div class="summary-field">
                <p class="form-label">{{ labels.payer('vatNumber') }}</p>
                <p class="form-value">{{ parsedPayerData['vatNumber'] }}</p>
              </div>
            }
            @if (parsedPayerData['companyName']) {
              <div class="summary-field">
                <p class="form-label">{{ labels.payer('companyName') }}</p>
                <p class="form-value">{{ parsedPayerData['companyName'] }}</p>
              </div>
            }
            @if (parsedPayerData['legalForm']) {
              <div class="summary-field">
                <p class="form-label">{{ labels.payer('legalForm') }}</p>
                <p class="form-value">{{ getLegalEntityFormName(parsedPayerData['legalForm']) }}</p>
              </div>
            }
          </div>
        </div>
      }

      @if (application.payerType === 'FreeOfCharge' && application.payerFreeOfChargeReason) {
        <div class="summary-card">
          <div class="summary-grid">
            <div class="summary-field">
              <p class="form-label">{{ labels.field('payer', 'freeOfChargeReason') }}</p>
              <p class="form-value">{{ application.payerFreeOfChargeReason }}</p>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Invoice delivery -->
    <div class="summary-subsection">
      <div class="summary-subsection-header">
        <h5 class="summary-subsection-title">{{ labels.section('invoiceDelivery') }}</h5>
        <app-tooltip text="infoRequestInvoiceDelivery" />
      </div>
      <p class="form-value">{{ getInvoiceDeliveryLabel() }}</p>

      @if (application.invoiceDeliveryMethod === 'Email' && application.invoiceDeliveryDetail) {
        <div class="summary-card">
          <div class="summary-field">
            <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.email' | translate }}</p>
            <p class="form-value">{{ application.invoiceDeliveryDetail }}</p>
          </div>
        </div>
      }

      @if (application.invoiceDeliveryMethod === 'EAddress' && application.invoiceDeliveryDetail) {
        <div class="summary-card">
          <div class="summary-field">
            <p class="form-label">{{ labels.field('invoiceDelivery', 'detailEAddress') }}</p>
            <p class="form-value">{{ application.invoiceDeliveryDetail }}</p>
          </div>
        </div>
      }

      @if (application.invoiceDeliveryMethod === 'PostalMail' && application.invoiceDeliveryDetail) {
        <div class="summary-card">
          <div class="summary-field">
            <p class="form-label">{{ labels.field('invoiceDelivery', 'detailAddress') }}</p>
            <p class="form-value">{{ application.invoiceDeliveryDetail }}</p>
          </div>
        </div>
      }

      @if (application.invoiceDeliveryMethod === 'Archive' && application.invoiceDeliveryStructuralUnitId) {
        <div class="summary-card">
          <div class="summary-field">
            <p class="form-label">{{ labels.field('invoiceDelivery', 'structuralUnit') }}</p>
            <p class="form-value">{{ application.invoiceDeliveryStructuralUnitName || getStructuralUnitName(application.invoiceDeliveryStructuralUnitId) }}</p>
          </div>
        </div>
      }
    </div>

    <!-- Purpose (FP only) -->
    @if (!isOrganization) {
      <div class="summary-subsection">
        <div class="summary-subsection-header">
          <h5 class="summary-subsection-title">{{ labels.section('purpose') }}</h5>
          <app-tooltip text="infoRequestPurpose" />
        </div>
        <p class="form-value">{{ getPurposeLabel() }}</p>

        @if (application.purposeInstitutionName || application.vsaaFlag) {
          <div class="summary-card">
            @if (application.purposeInstitutionName) {
              <div class="summary-field">
                <p class="form-label">{{ labels.field('purpose','institutionName') }}</p>
                <p class="form-value">{{ application.purposeInstitutionName }}</p>
              </div>
            }
            @if (application.vsaaFlag) {
              <div class="vsaa-flag">
                <img src="assets/images/new-check.svg" alt="check" />
                <span>{{ labels.field('purpose','vsaa') }}</span>
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- Service Deadline -->
    <div class="summary-subsection">
      <div class="summary-subsection-header">
        <h5 class="summary-subsection-title">{{ 'pages.service.infoRequest.clientPayer.deadlineTitle' | translate }}</h5>
        <app-tooltip text="infoRequestDeadline" />
      </div>
      <p class="form-value">{{ getDeadlineLabel() }}</p>
      @if (application.serviceDeadline === 'Other' && application.deadlineDate) {
        <div class="summary-card">
          <div class="summary-field">
            <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.serviceDeadlineDate' | translate }}</p>
            <p class="form-value">{{ formatDatetime(application.deadlineDate) }}</p>
          </div>
        </div>
      }
    </div>

    <!-- Response delivery -->
    <div class="summary-subsection">
      <div class="summary-subsection-header">
        <h5 class="summary-subsection-title">{{ labels.section('responseDelivery') }}</h5>
        <app-tooltip text="infoRequestResponseDelivery" />
      </div>
      <p class="form-value">{{ getResponseDeliveryLabel() }}</p>

      @if (application.responseDeliveryMethod === 'Email' && application.responseDeliveryDetail) {
        <div class="summary-card">
          <div class="summary-field">
            <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.email' | translate }}</p>
            <p class="form-value">{{ application.responseDeliveryDetail }}</p>
          </div>
        </div>
      }

      @if (application.responseDeliveryMethod === 'EAddress' && application.responseDeliveryDetail) {
        <div class="summary-card">
          <div class="summary-field">
            <p class="form-label">{{ labels.field('responseDelivery', 'detailEAddress') }}</p>
            <p class="form-value">{{ application.responseDeliveryDetail }}</p>
          </div>
        </div>
      }

      @if (application.responseDeliveryMethod === 'PostalMail' && application.responseDeliveryDetail) {
        <div class="summary-card">
          <div class="summary-field">
            <p class="form-label">{{ labels.field('responseDelivery', 'detailAddress') }}</p>
            <p class="form-value">{{ application.responseDeliveryDetail }}</p>
          </div>
        </div>
      }

      @if (application.responseDeliveryMethod === 'Archive' && application.responseDeliveryStructuralUnitId) {
        <div class="summary-card">
          <div class="summary-field">
            <p class="form-label">{{ labels.field('responseDelivery', 'structuralUnit') }}</p>
            <p class="form-value">{{ application.responseDeliveryStructuralUnitName || getStructuralUnitName(application.responseDeliveryStructuralUnitId) }}</p>
          </div>
        </div>
      }
    </div>

    <!-- BO Fields -->
    <div class="summary-subsection">
      <div class="summary-subsection-header">
        <h5 class="summary-subsection-title">{{ 'pages.service.infoRequest.clientPayer.boExtraFieldsTitle' | translate }}</h5>
      </div>
      <div class="summary-grid">
        <div class="summary-field">
          <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.letterNumber' | translate }}</p>
          <p class="form-value">{{ application.letterNumber || '-' }}</p>
        </div>
        <div class="summary-field">
          <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.aboutSubject' | translate }}</p>
          <p class="form-value">{{ application.aboutSubject || '-' }}</p>
        </div>
        <div class="summary-field">
          <p class="form-label">{{ 'pages.service.infoRequest.clientPayer.submissionChannel' | translate }}</p>
          <p class="form-value">{{ getSubmissionMethodLabel() }}</p>
        </div>
      </div>
      @if (application.requiresRestrictedAccess) {
        <div class="restricted-access mt-16">
          <img src="assets/images/danger-exclamation-mark.svg" alt="warning" />
          <span>{{ 'pages.service.infoRequest.clientPayer.restrictedAccess' | translate }}</span>
        </div>
      }
    </div>

    <!-- Notes -->
    <div class="summary-subsection">
      <div class="summary-subsection-header">
        <h5 class="summary-subsection-title">{{ labels.section('notes') }}</h5>
        <app-tooltip text="infoRequestNotes" />
      </div>
      <p class="form-value">{{ application.notes || '-' }}</p>
    </div>
  </div>
</div>

<!-- Actions -->
<app-service-form-actions
  [isFirstStep]="false"
  [isLastStep]="true"
  [isNew]="false"
  [showSaveDraft]="false"
  [isSubmitting]="isSubmitting"
  [showSubmit]="isDraft"
  (exit)="goBack()"
  (deleteDraft)="onDelete()"
  (continue)="onSubmit()" />

<!-- Submit Confirmation Modal -->
<app-confirm-modal
  [isOpen]="isConfirmSubmit"
  (confirm)="confirmSubmit()"
  (cancel)="isConfirmSubmit = false"
  title="submitConfirmTitle"
  bodyText="submitConfirmBody"
  confirmText="submitApplication"
  denyText="cancel" />

<!-- Delete Confirmation Modal -->
<app-confirm-modal
  [isOpen]="isConfirmDelete"
  (confirm)="confirmDelete()"
  (cancel)="isConfirmDelete = false"
  title="deleteDraftConfirmTitle"
  bodyText="deleteDraftConfirmBody"
  confirmText="delete"
  denyText="cancel" />
